import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { tracks } from '../../data/tracks';
import TrackCard from './TrackCard';
import TrackModal from './TrackModal';
import './Music.css';

const Music = () => {
  const { t } = useTranslation();
  const [selectedTrack, setSelectedTrack] = useState(null);

  return (
    <section className="music section" id="music">
      <div className="container">
        <h2 className="section-title">{t('music.title')}</h2>
        <p className="music-subtitle">{t('music.availableOn')}</p>
        <div className="tracks-grid">
          {tracks.map((track) => (
            <TrackCard 
              key={track.id} 
              track={track}
              onClick={() => setSelectedTrack(track)}
            />
          ))}
        </div>
      </div>
      {selectedTrack && (
        <TrackModal
          track={selectedTrack}
          onClose={() => setSelectedTrack(null)}
        />
      )}
    </section>
  );
};

export default Music;

